import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=e15e9bec&scoped=true"
import script from "./Rates.vue?vue&type=script&lang=js"
export * from "./Rates.vue?vue&type=script&lang=js"
import style0 from "./Rates.vue?vue&type=style&index=0&id=e15e9bec&prod&lang=scss&scoped=true"
import style1 from "./Rates.vue?vue&type=style&index=1&id=e15e9bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15e9bec",
  null
  
)

export default component.exports